<template>
  <div class="goods meeting">
    <v-head :title="title"></v-head>
    <div>
      <van-swipe
        class="my-swipe"
        :autoplay="3000"
        indicator-color="white"
        style="height:6.5rem"
      >
        <van-swipe-item v-for="(item, index) in list.content" :key="index">
          <div
            class="acd"
            :style="{ backgroundImage: 'url(' + item.photoId + ')' }"
          >
<!--            <img src="../../assets/images/yuansu.jpg" v-if="!item.photoId" />-->
          </div>
        </van-swipe-item>
      </van-swipe>
    </div>
    <div class="content">
      <!-- <div>
		<van-dropdown-menu>
			<van-dropdown-item v-model="value1" :options="option1" />
			<van-dropdown-item v-model="value2" :options="option2" />
			<van-dropdown-item v-model="value3" :options="option3" />
		</van-dropdown-menu>
	  </div> -->
      <div class="list">
        <!-- <p class="warmTip" v-if="list.content && !list.content.length">没有数据了～</p> -->

        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <!-- <van-cell v-for="(item,index) in list.content" :key="index" @click="goDetail(item.id)"/> -->
          <ul class="meeting_box">
            <li
              v-for="(item, index) in list.content"
              :key="index"
              @click="goDetail(item)"
            >
              <span class="imgBox"><img :src="item.photoId" alt class/></span>
              <div class="fonts">
                <h4>{{ item.name }}</h4>
                <p>举办时间： {{ item.startDate | limitDate }}</p>
                <p>报名时间： {{ item.registerStartDate | limitDate }}</p>
                <p>
                  举办地点：
                  {{ searchAdd(item.province) }}
                  <template v-if="item.province !== item.city">{{
                    searchAdd(item.city)
                  }}</template>
                  <!-- <b>已经结束</b> -->
                </p>
              </div>
              <div style="clear:both"></div>
              <van-divider />
            </li>
          </ul>
        </van-list>

        <!-- <ul class="meeting_box">
		  	  <li v-for="(item,index) in list.content" :key="index"  @click="goDetail(item.id)">
		  	  	<span class="imgBox"><img :src="item.photoId" alt class></span>
		  	  	<div class="fonts">
					<h4 >{{item.name}}</h4>
					<p>举办时间： {{item.startDate | limitDate}}</p>
					<p>报名时间： {{item.registerStartDate | limitDate}}</p>
					<p>举办地点： {{item.provinceName}} <b>已经结束</b></p>
		  	  	</div>
				<div style="clear:both"></div>
				<van-divider />	
		  	  </li>
		  	</ul> -->
        <!-- <div style=" height:60px; text-align:center; margin-top:-20px">
				<van-loading size="24px">加载中...</van-loading> 
			</div> -->
      </div>
    </div>
    <vNavbar :active="navActive" @on_chang_active="changActive"></vNavbar>
  </div>
</template>

<script>
import vHead from "../../components/header.vue";
import vNavbar from "../../components/navbar.vue";
import {
  Icon,
  Row,
  Col,
  Button,
  Tab,
  Tabs,
  Swipe,
  SwipeItem,
  DropdownMenu,
  DropdownItem,
  Loading,
  Divider,
  List,
  Cell,
} from "vant";
import { mapGetters, mapMutations, mapActions } from "vuex";
import {
  getMeetingAll,
  getMeetingPageAll,
  getPZUrl,
  getNotstarted,
  getDivisionData,
  getStartingMeeting,
  getUser,
} from "@/api/dictionary";
import { getSessionStore } from "@/utils/sessionStorage.js";
export default {
  data() {
    return {
      finished: false,
      // active: 1,
      navActive: 2,
      loading: false,
      type: "starting",
      page: -1,
      list: { content: [] },
      userInfo: {},
      title: "会议中心",
      value1: 0,
      value2: "a",
      value3: "a",
      option1: [
        { text: "不限月份", value: 0 },
        { text: "近5个月", value: 1 },
        { text: "近10个月", value: 2 },
        { text: "近一年", value: 3 },
      ],
      option2: [
        { text: "不限地点", value: "a" },
        { text: "北京", value: "b" },
        { text: "南京", value: "c" },
      ],
      option3: [
        { text: "不限状态", value: "a" },
        { text: "正在报名", value: "b" },
        { text: "已经结束", value: "c" },
      ],
    };
  },
  components: {
    vHead,
    vNavbar,
    [Button.name]: Button,
    [Row.name]: Row,
    [Col.name]: Col,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Loading.name]: Loading,
    [Divider.name]: Divider,
    [List.name]: List,
    [Cell.name]: Cell,
  },
  watch: {
    type(val) {
      this.page = 0;
      this.getDate();
    },
  },
  methods: {
    ...mapActions(["getGroupMemberType", "getPersonMemberType"]),
    ...mapMutations(["setAddrList"]),
    chufa(name, title) {
      this.type = name;
    },
    goPath(pathName) {
      this.$router.push({ name: pathName });
    },
    formatTime: function(dateUnix) {
      if (!dateUnix) return null;
      let time = dateUnix.substring(0, 10);
      return time;
    },
    goDetail(item) {
      if (!this.userInfo || Object.keys(this.userInfo).length === 0 || !this.userInfo.id) {
        this.$router.push({ name: 'login' });
        return;
      }
     if(this.userInfo.memberCategory==1){
      this.$router.push({ name: "signup", query: { meetingId: item.id,type: 1 }});
     }else{
      this.$router.push({ name: "signUpPage", query: { meetingId: item.id}});
     }
    },
    changActive(val) {
      this.navActive = val;
    },
    getDate() {
      let params = {
        memberId: getSessionStore("memberId"),
        participantsIdentity: this.userInfo.identity,
        adminIdentity: this.userInfo.branchIdentity,
        participantsCode: this.userInfo.recommendUnitId,
      };
      getMeetingAll(params, this.page).then((res) => {
        if (res.success) {
          let meetingList = res.result.content;
          for (let i = 0; i < meetingList.length; i++) {
            let params = {
              id: meetingList[i].photoId,
            };
            getPZUrl(params).then((res) => {
              meetingList[i].photoId = res.result;
            });
          }
          this.list = res.result;
        }
      });
    },
    onLoad() {
      // 异步更新数据
      let params = {};
      this.page = this.page + 1;
      getMeetingPageAll(params, this.page).then((res) => {
        if (res.success) {
          let meetingList = res.result.content;
          for (let i = 0; i < meetingList.length; i++) {
            let params = {
              id: meetingList[i].photoId,
            };
            getPZUrl(params).then((res) => {
              meetingList[i].photoId = res.result;
            });

            if (!this.list.content) {
              this.list.content.length = 0;
            } else {
              this.list.content.push(meetingList[i]);
            }
          }
          this.loading = false;
          //   this.list.push(this.list.length + 1);
          //    this.list = res.result;
          if (this.list.content.length >= res.result.totalElements) {
            this.finished = true;
          }
        }
      });
      //   setTimeout(() => {
      //     for (let i = 0; i < 10; i++) {
      //       this.list.push(this.list.length + 1);
      //     }

      //     // 加载状态结束
      //     this.loading = false;

      //     // 数据全部加载完成
      //     if (this.list.length >= 40) {
      //       this.finished = true;
      //     }
      //   }, 1000);
    },
    changePage: function(val) {
      this.page = val;
      this.getDate();
    },
    getUserInfo() {
      if (sessionStorage.getItem("access_token")) {
 getUser().then((res) => {
        if (res.success) {
          this.userInfo = res.result;
          this.gender = res.result.gender;
        }
      });
      }
     
    },
  },
  computed: {
    ...mapGetters(["getMemberType","getCityList","searchAdd"]),
  },
  mounted() {
    // this.getDate();
    this.getUserInfo();
    this.getPersonMemberType();
    getDivisionData().then(res => {
          this.setAddrList(res.result);
          });
  },
};
</script>

<style lang="less" scoped>
.means {
  padding: 60px 13px 15px 13px;
  background: url(../../assets/images/hy_bg.jpg);
  background-size: 100%;
  overflow: hidden;
  .van-button {
    float: right;
    background: #fff;
    color: #378be1;
    border: none;
    line-height: 26px;
    height: 35px;
    margin-top: 8px;
  }
}
.meeting /deep/.van-nav-bar__title,
.meeting /deep/.van-nav-bar__text {
  color: #000 !important;
}
.meeting /deep/.sign_out {
  color: #000 !important;
}
.portrait {
  width: 15%;
  float: left;
}
.means_name {
  float: left;
  font-size: 14px;
  color: #fff;
  margin-top: 5px;
  line-height: 24px;
  margin-left: 10px;
}
.more {
  float: right;
  margin-top: 8px;
  color: #fff;
}
.means_top {
  overflow: hidden;
}
.means_top img {
  border-radius: 100%;
}
.mean_bottom {
  font-size: 14px;
  color: #fff;
  margin-top: 15px;
  .left_c {
    float: left;
    line-height: 26px;
  }
}

.menu {
  padding: 15px 0;
  border-bottom: #f2f2f2 8px solid;
  .van-col {
    text-align: center;
    img {
      display: block;
      width: 28%;
      margin: 0 auto;
    }
    span {
      font-size: 13px;
      margin-top: 10px;
      display: block;
    }
  }
}
.meeting_box {
  margin-bottom: -30px;
  padding: 15px;
  img {
    width: 100%; /*max-height: 5.2rem*/
    min-height: 100%;
    border-radius: 5px;
  }
  li {
    overflow: hidden;
  }
  .van-button {
    float: right;
    background: #378be1;
    color: #fff;
    border: none;
    line-height: 26px;
    height: 30px;
    margin-top: 8px;
    position: absolute;
    bottom: 15px;
    right: 0px;
  }
}
.meeting_box li .imgBox {
  width: 36%;
  height: 2rem;
  background: url(../../assets/images/mor.jpg) center no-repeat;
  background-size: cover;
  display: flex;
  border-radius: 5px;
  float: left;
  margin-right: 15px;
  align-items: center;
  overflow: hidden;
}
.meeting_box li .fonts {
  font-size: 13px;
  float: left;
  width: 58%;
}
.meeting_box li .fonts h4 {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 0.4rem;
  margin-bottom: 0.2rem;
  color:#000
}
.meeting_box li .fonts p{ line-height: 20px;}
.meeting_box li .fonts p b {
  text-align: right;
  float: right;
}
/deep/.van-tabs__line {
  z-index: 0;
}
.tabbtn {
  width: 100%;
  display: inline-flex;
}
.tabbtn li {
  width: 33.3%;
  text-align: center;
  font-size: 14px;
  padding: 20px 0;
  border-bottom: #dfdfdf solid 2px;
}
.tabbtn li.current {
  border-color: red;
}
.content {
  margin-bottom: 60px;
}
.content p.warmTip {
  text-align: center;
  font-size: 14px;
  margin-top: 50px;
}

.acd {
  background-size: 100%;
  background-color: #378be1;
  height: 100%;
  width: 100%;
  background-position: center;
}
.my-swipe .van-swipe-item {
  color: #fff;
  font-size: 20px;
  line-height: 150px;
  margin-top: 55px;
  height: 5rem;
  text-align: center;
  background-color: #39a9ed;
}
.my-swipe .van-swipe-item img {
  width: 100%;
  height: 5.5rem;
}
</style>
